import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useNavigate, useParams } from "react-router";
import { useFormik } from "formik";
import * as Yup from "yup";
import { request } from "../../config/request.ts";
import { toast } from "react-toastify";
import PageHeader from "../../shared/PageHeader/index.tsx"; 
import TextField from "../../shared/TextField/index.tsx";
import SelectField from "../../shared/SelectField/index.tsx";
import PageWrapper from "../../shared/PageWrapper/index.tsx";
import "../../styles/scss/Form.scss";

export default function CustomerCreateEdit() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
      email: "",
      customerType: "Customer",
      noOfWashes: 0,
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Name is required"),
      phone: Yup.string().required("Phone number is required"),
      email: Yup.string().email("Invalid email").nullable(),
      customerType: Yup.string().required("Customer type is required"),
    }),
    onSubmit: async (values) => {
      try {
        let response;
        if (id) {
          response = await request.put("/api/updateCustomer/" + id, values);
        } else {
          response = await request.post("/api/createCustomer", values);
        }

        if (response?.data?.status) {
          toast.success("Customer saved successfully!");
          navigate("/admin/customers");
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            "An error occurred. Please try again.",
        );
      }
    },
  });

  useEffect(() => {
    if (id) {
      const fetchCustomer = async () => {
        setLoading(true);
        try {
          const response = await request.get(`/api/getCustomerById/${id}`);
          const customer = response.data.data;
          formik.setValues({
            name: customer.name || "",
            phone: customer.phone || "",
            email: customer.email || "",
            customerType: customer.customerType || "Customer",
            // noOfWashes: customer.noOfWashes ?? 0,
          });
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      };

      fetchCustomer();
    }
  }, [id]);

  return (
    <PageWrapper loading={loading}>
      <Box className="form-container">
        <Box className="form-page">
          <Box className="form-header">
            <PageHeader
              title={
                id && id !== "new" ? "Edit Customer" : "Create New Customer"
              }
              secondaryButton={{
                label: "Cancel",
                onClick: () => navigate("/admin/customers"),
              }}
              primaryButton={{
                label:
                  id && id !== "new" ? "Update Customer" : "Create Customer",
                icon: <span className="material-symbols-outlined">save</span>,
                onClick: () => formik.handleSubmit(),
              }}
            />
          </Box>

          <Box className="form-card">
            <Box className="form-card-body">
              <Box className="form-grid form-grid--2">
                <Box className="form-field">
                  <TextField
                    name="name"
                    label="Name"
                    type="text"
                    formik={formik}
                    autoFocus
                  />
                </Box>
                <Box className="form-field">
                  <TextField
                    name="phone"
                    label="Phone"
                    type="text"
                    formik={formik}
                  />
                </Box>
              </Box>
              <Box
                className="form-grid form-grid--2"
                style={{ marginTop: "16px" }}
              >
                <Box className="form-field">
                  <TextField
                    name="email"
                    label="Email"
                    type="text"
                    formik={formik}
                  />
                </Box>
                <Box className="form-field">
                  <SelectField
                    name="customerType"
                    label="Customer Type"
                    formik={formik}
                    options={[
                      { value: "Customer", label: "Customer" },
                      { value: "Dealer", label: "Dealer" },
                      { value: "Workshop", label: "Workshop" },
                      { value: "Showrooms", label: "Showrooms" },
                      { value: "Polishing Shops", label: "Polishing Shops" },
                      { value: "Polishing Shops", label: "Polishing Shops" },
                      {
                        value: "Car Rental Entrepreneur",
                        label: "Car Rental Entrepreneur",
                      },
                      {
                        value: "Car Painting Workshops",
                        label: "Car Painting Workshops",
                      },
                      { value: "Taxi Driver", label: "Taxi Driver" },
                    ]}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </PageWrapper>
  );
}
